import URL from '../api_url';

export const MEETING_API = `${URL}/meeting`;

export const MEETINGS_API = `${URL}/meetings`;